export class SmartQFreeMoveEvent {
  static type = "smartq:freemove"

  constructor(data) {
    this.data = data
  }

  get dragEvent() {
    return this.data.dragEvent
  }

  get type() {
    return this.constructor.type
  }
}

export class SmartQMoveEvent {
  static type = "smartq:move"

  constructor(data) {
    this.data = data
  }

  get dragEvent() {
    return this.data.dragEvent
  }

  get type() {
    return this.constructor.type
  }
}

export class SmartQGroupEvent {
  static type = "smartq:group"

  constructor(data) {
    this.data = data
  }

  get dragEvent() {
    return this.data.dragEvent
  }

  get type() {
    return this.constructor.type
  }
}

export class SmartQMultiMoveEvent {
  static type = "smartq:mutlimove"

  constructor(data) {
    this.data = data
  }

  get dragEvent() {
    return this.data.dragEvent
  }

  get type() {
    return this.constructor.type
  }
}
